import { render, staticRenderFns } from "./processed.vue?vue&type=template&id=645eba49"
import script from "./processed.vue?vue&type=script&lang=js"
export * from "./processed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports